import { memo, useCallback } from "react";

import { Row } from "@narmi/design_system";

import styles from "../../SearchBar.module.scss";

import type { RowProps } from "./types";

interface MultiRowProps extends RowProps {
  subtitle: string;
}

const MultiRow = ({
  title,
  subtitle,
  rightItem,
  onClickRow,
  route,
}: MultiRowProps) => {
  const handleActivate = useCallback(() => {
    if (onClickRow) {
      onClickRow();
    } else if (route) {
      window.location.assign(route);
    }
  }, [onClickRow, route]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleActivate();
      }
    },
    [handleActivate]
  );

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={`${title}, ${subtitle}`}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
      className={styles["results-row-container"]}
      data-testid="search-multi-row"
    >
      <Row alignItems="center" gapSize="s">
        <Row.Item className={styles["results-multi-row-title-container"]}>
          <span className={styles["results-monetary-title"]}>{title}</span>
          <span className={styles["results-monetary-subtitle"]}>
            {subtitle}
          </span>
        </Row.Item>
        {rightItem && <Row.Item shrink>{rightItem}</Row.Item>}
      </Row>
    </div>
  );
};

export default memo(MultiRow);
